import type { JwtTokenPair, SocialLoginRequest, TokenRefresh } from 'api';
import { AUTH } from 'common/endpoints';
import BaseService from './base';

export interface TokenPayload {
  username: string;
  password: string;
}

interface PasswordResetPayload {
  email: string;
}

interface PasswordChangePayload {
  new_password: string;
  re_new_password: string;
  uid: string;
  token: string;
}

export interface RefreshTokenPayload {
  refresh?: string;
}

export interface VerifyAccessTokenPayload {
  token: string;
}

class AuthService extends BaseService {
  static instance: AuthService;

  constructor() {
    super();
    if (!AuthService.instance) {
      AuthService.instance = this;
    }
  }

  static getInstance() {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  getAccessTokens = (payload: TokenPayload) => this.post<JwtTokenPair, TokenPayload>(AUTH.getAccessTokens, payload);

  sendAccessToken = (payload: SocialLoginRequest) => this.postNoAuth(AUTH.sendAccessToken, payload);

  refreshAccessToken = (payload: string | RefreshTokenPayload) =>
    this.post<TokenRefresh, string | RefreshTokenPayload>(AUTH.refreshAccessToken, payload);

  verifyAccessToken = (accessToken: VerifyAccessTokenPayload) => this.post(AUTH.verifyAccessToken, accessToken);

  createUser = (data: unknown) => this.postNoAuth(AUTH.createUser, data);

  getUserInfo = () => this.get(AUTH.getUserInfo);

  updateUserProfileInfo = (payload: unknown) => this.put(AUTH.updateUserProfileInfo, payload);

  activateUser = (uid: string, token: string) => this.postNoAuth(AUTH.activateUser, { uid, token });

  resendActivationEmail = (email: string) => this.postNoAuth(AUTH.resendActivationEmail, { email });

  sendPasswordReset = (payload: PasswordResetPayload) => this.postNoAuth(AUTH.resetPassword, payload);

  sendPasswordChange = (payload: PasswordChangePayload) => this.postNoAuth(AUTH.passwordChange, payload);
}

export default AuthService;
